module.exports = __webpack_public_path__ + "img/Icon_btn_video.31bd4cce.svg";